import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  connect() {    
    const dependantContainer = document.getElementById('dependantContainer')

    if (!dependantContainer) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.target === dependantContainer) {
            if (entry.isIntersecting) {
              this.element.classList.add('opacity-0')
              this.element.classList.remove('opacity-100')
            } else {
              this.element.classList.add('opacity-100')
              this.element.classList.remove('opacity-0')
            }
          }
        })
      },
      {
        root: null,
        threshold: 0
      }
    )

    this.observer.observe(dependantContainer)
  }

  disconnect() {
    this.observer.disconnect()
  }
}
